// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qa-0";